export { default } from './SampleRegistriesView'
